import styled from "styled-components";

export const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: 3px;
`;
